import React from 'react';
import IProcedureSummary from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureSummary';
import { Guid } from '@Shared.Angular/@types/guid';

type Props = {
  procedure: IProcedureSummary;
  onClick: (procedureId: Guid) => void;
};

const ProcedureSummary = (props: Props) => {
  const { procedure } = props;

  return (
    <div
      className="procedure-summary"
      onClick={() => props.onClick(procedure.id)}
    >
      <div>{procedure.name}</div>
    </div>
  );
};

export default ProcedureSummary;
